<template>
  <button class="labeledbutton bg-transparent border-0" @click="onClick">
    <div class="buttonWrapper">
      <p class="buttonLabel">{{ label }}</p>
      <img class="labeledbutton__icon" :src="displayedIcon" />
    </div>
  </button>
</template>

<script>
export default {
  name: "LabeledButton",
  props: {
    label: String,
    onClick: {
      type: Function,
      required: false,
      default: () => {}
    },
    icon: String
  },
  computed: {
    displayedIcon() {
      if (this.icon === "book") {
        return this.$store.getters.image_button_prospekt_without_text;
      }
      return this.$store.getters.image_button_arrow_right;
    }
  }
};
</script>

<style scoped>
.labeledbutton {
  padding: 0;
}
.buttonWrapper {
  font-family: "Netto Black", "Open Sans", sans-serif;
  display: flex;
  align-items: center;
}
.buttonLabel {
  white-space: nowrap;
}
.labeledbutton__icon {
  width: 3rem;
  margin-left: 1rem;
  height: auto;
}
@media (max-width: 575.98px) {
  .labeledbutton__icon {
    max-width: 36px;
    max-height: 36px;
  }
  .buttonLabel {
    font-size: 13px;
  }
  img {
    width: 2rem;
    margin-left: 0.5rem;
  }
}
@media (max-width: 767.98px) and (min-width: 576px) {
  .buttonLabel {
    font-size: 13px;
  }
}
@media (max-width: 991.98px) and (min-width: 768px) {
  .buttonLabel {
    font-size: 15px;
  }
}
@media (max-width: 1199.98px) and (min-width: 992px) {
  .buttonLabel {
    font-size: 18px;
  }
}
@media (min-width: 1200px) {
  .buttonLabel {
    font-size: 18px;
  }
}
</style>
